import {environment} from "../../environments/environment";

function makeAppConfig() {
  const date = new Date();
  const year = date.getFullYear();

  const AppConfig = {
    year,
    AutoCloseMobileNav: true,
    ApiHost: "http://localhost:8080"
  };

  return AppConfig;
}

export const APPCONFIG = makeAppConfig();



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/config.ts